import { HapticOption } from "./types";

const haptic = async (variant: HapticOption = "Medium") => {};
export default haptic;
